import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { PieChart as PieChartIcon } from "lucide-react"

export const EmptyRacesState = () => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <PieChartIcon className="h-5 w-5" />
        Estadísticas de Razas
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-center text-muted-foreground py-4">Este juego no tiene razas definidas.</p>
    </CardContent>
  </Card>
)
